// Quick implementation using the existing pagination
// Worth considering writing a new pagination with Next JS Link component instead?
import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { refreshGridProducts } from "actions/products-actions";

import GridPagination from "../new_taxonomy/grid-pagination";
import PropTypes from "prop-types";

const GridNav = ({ totalPages }) => {
  const currentPage = useSelector(state => parseInt(state.currentPage));
  const gridCount = useSelector(state => state.gridCount);
  const [enableNext, setEnableNext] = useState(false);
  const [enablePrevious, setEnablePrevious] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const nextEnabled = currentPage < totalPages;
    const previousEnabled = currentPage > 1;

    setEnableNext(nextEnabled);
    setEnablePrevious(previousEnabled);
  }, [currentPage, gridCount]);

  function handleChangePage(path) {
    const params = new URLSearchParams(path.split("?")[1]);
    dispatch(refreshGridProducts(params.get("page")));
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  return (
    <div style={{ padding: "20px 50px 20px 0", display: "flex", justifyContent: "end" }}>
      <GridPagination
        path={"/clearance/products"}
        page={currentPage}
        totalPages={totalPages}
        nextPage={enableNext}
        previousPage={enablePrevious}
        resultsCount={totalPages}
        onChangePage={path => handleChangePage(path)}
      />
    </div>
  );
};

GridNav.propTypes = {
  totalPages: PropTypes.string,
};

export default GridNav;
